<template>
  <div class="map-point">
    <div class="map-body">
      <div id="map"></div>
      <div class="form-action">
        <button
          text
          @click="cancel"
          class="btn btn-default gray"
        >
          {{ $t('Отмена') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// openlayer library
import 'ol/ol.css'
import { Circle, Fill, Style } from 'ol/style'
import { Feature, Map, View } from 'ol/index'
import { OSM, Vector as VectorSource } from 'ol/source'
import { Point } from 'ol/geom'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'

export default {
  data () {
    return {
      map: null,
      zoom: 6.5,
      center: [74.84179757026465, 41.265951305427194]
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    initCoordinates (coordinates) {
      const div = document.querySelector('#map')
      if (div && div.children) {
        [].slice.call(div.children).forEach(
          child => div.removeChild(child)
        )
      }
      const point = new Point(coordinates)
      this.map = new Map({
        target: 'map',
        view: new View({
          projection: 'EPSG:4326',
          center: this.center,
          zoom: this.zoom
        }),
        layers: [
          new TileLayer({
            source: new OSM()
          }),
          new VectorLayer({
            source: new VectorSource({
              features: [new Feature(point)]
            }),
            style: new Style({
              image: new Circle({
                radius: 6,
                fill: new Fill({ color: 'green' })
              })
            })
          })
        ]
      })
    }
  }
}
</script>
<style scoped>
#map {
  width: 100%;
  height: 400px;
  background-color: #e7e9f6;
}
</style>
